// extracted by mini-css-extract-plugin
module.exports = {"h2":"aed17b9412--h2--fCSbd"};